export class EverywhereSuccessCodes {
  static GET = "S1";
  static POST = "S2";
  static PATCH = "S3";
  static PUT = "S4";
  static DELETE = "S5";
}
